import React from 'react';
import { Modal } from 'client/components/common/Modal';
import { canSearch } from 'src/utils/searchCondition';

type Props = {
  areaIds?: string[];
  conditionList: JSX.Element;
  handlers: {
    handleClickClose: () => void;
    handleClickClear: () => void;
  };
};

export const SearchConditionModal = ({
  areaIds,
  conditionList,
  handlers: { handleClickClear, handleClickClose },
}: Props) => {
  const onClose = canSearch({ prefectureIds: areaIds }) ? handleClickClose : undefined;
  return (
    <>
      <Modal title="絞り込み条件" onClose={onClose} onClear={handleClickClear}>
        {conditionList}
      </Modal>
    </>
  );
};
